var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper",attrs:{"id":"map-box2"}},[_c('div',{staticClass:"map-container",attrs:{"id":"mapContainer2"}})])
}]

export { render, staticRenderFns }